import mainHeader from "./mainHeader.component";

const mainHeaderModule = angular
  .module("app.components.mainHeader", [])
  .component("mainHeader", mainHeader);

export default mainHeaderModule;



// WEBPACK FOOTER //
// ./src/components/mainHeader/mainHeader.module.js